import type { Brand } from "@src/domain/entities/brand/Brand";
import type { UpdateBrandStatusDTO } from "@src/domain/dto/brands/UpdateBrandStatus.dto";
import type { IBrandRepository } from "@src/domain/repositories/brand";

export class UpdateBrandStatusUseCase {
  private readonly brandRepository: IBrandRepository;

  constructor(brandRepository: IBrandRepository) {
    this.brandRepository = brandRepository;
  }

  async execute(params: UpdateBrandStatusDTO): Promise<Brand> {
    try {
      const brand = await this.brandRepository.updateBrandStatus(params);
      if (!brand) throw new Error("No brand found");
      return brand;
    } catch (error) {
      console.error("Failed to update brand status:", error);
      throw new Error("Failed to update brand status");
    }
  }
}
